import { PickUpInfoResponse } from '@/types/api/v1/PickUpInfoResponse';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
const url = ApiUrl.Read.PICK_UP_INFO;
const useGetPickUpInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<PickUpInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);
  return {
    execute
  };
};
export default useGetPickUpInfo;